// extracted by mini-css-extract-plugin
module.exports = {"background":"timeDisplay_background__jk3Vu","panel":"timeDisplay_panel__1PXRa","screen":"timeDisplay_screen__1xZj_","time":"timeDisplay_time__cC6_W"};